import { IsEmail } from 'class-validator';
import { Entity } from './entity.js';

export class UserEntity extends Entity
{
    @IsEmail()
    email!: string;
}